import * as React from 'react';
import useCategory from '../hooks/useCategory';
export const Category = ({ children }) => {
    const category = useCategory();
    if (!category)
        return null;
    return React.createElement(React.Fragment, null, children(category));
};
Category.displayName = 'Category.Fetch';
//# sourceMappingURL=categoryFetch.js.map